declare global {
  interface Window {
    __publishBooted?: boolean
    __publishBootFailureShown?: boolean
    __publishRenderStarted?: boolean
    __publishClearBootWatchdog?: () => void
  }
}

/** Signals the inline boot watchdog that Publish mounted successfully. */
export function signalPublishBooted(): void {
  if (typeof window === 'undefined') {
    return
  }

  window['__publishBooted'] = true
  window['__publishClearBootWatchdog']?.()
}

/** Signals the inline boot watchdog that a boot failure UI is showing. */
export function signalPublishBootFailure(): void {
  if (typeof window === 'undefined') {
    return
  }

  window['__publishBootFailureShown'] = true
  window['__publishClearBootWatchdog']?.()
}
